import moment from 'moment'
import { getProgramDetails } from './programBookingLogic'
import { daysBetween } from '../utils/dateUtils'

function setCheckInTime(date) {
  return date.startOf('hour').hour(15)
}

function setCheckOutTime(date) {
  return date.startOf('hour').hour(12)
}

export function getBookableDates({
  isAuthenticated,
  isProgramBooking,
  program
}) {
  // let checkInMinDate =
  let checkInMinDate = moment()
  let checkInMaxDate = isAuthenticated ? undefined : moment().add(180, 'days')
  let checkOutMinDate = moment(checkInMinDate).add(1, 'day')
  let checkOutMaxDate
  let d
  if (isProgramBooking) {
    d = getProgramDetails(program)
    checkInMinDate = moment(d.checkInMinDate)
    checkInMaxDate = moment(d.checkInMaxDate)
    checkOutMinDate = moment(d.checkOutMinDate)
    checkOutMaxDate = moment(d.checkOutMaxDate)
  }

  checkInMinDate = checkInMinDate.startOf('day').toDate()
  checkOutMinDate = checkOutMinDate.startOf('day').toDate()
  checkInMaxDate = checkInMaxDate && checkInMaxDate.endOf('day').toDate()
  checkOutMaxDate = checkOutMaxDate
    ? checkOutMaxDate.endOf('day').toDate()
    : checkInMaxDate

  const ret = {
    checkInMinDate,
    checkInMaxDate,
    checkOutMinDate,
    checkOutMaxDate
  }

  if (d && d.checkInTime) {
    ret.checkInTime = d.checkInTime
  }

  if (d && d.checkOutTime) {
    ret.checkOutTime = d.checkOutTime
  }

  return ret
}

/**
 * Compares two dates
 * compare("11/07/2015", "10/07/2015") returns 1
 * @deprecated Use regular comparisons or moment methods instead
 */
function compare(momentA, momentB) {
  if (momentA > momentB) return 1
  else if (momentA < momentB) return -1
  else return 0
}

/**
 * Validates check-in and check-out dates before searching
 *
 * @param isAuthenticated
 * @param isProgramBooking
 * @param checkInDate
 * @param checkOutDate
 * @param today
 * @returns {*}
 */
export function validateDates(
  isAuthenticated,
  isProgramBooking,
  checkInDate,
  checkOutDate,
  today
) {
  if (!checkInDate || !checkOutDate) {
    return {
      valid: false,
      errors: ['Please select the Check-in and Check-out dates.']
    }
  }

  let momentA = moment(checkInDate)
  let momentB = moment(checkOutDate)
  let momentAZero = moment(
    momentA
      .startOf('hour')
      .hour(0)
      .toDate()
  )
  let momentBZero = moment(
    momentB
      .startOf('hour')
      .hour(0)
      .toDate()
  )
  if (
    !isAuthenticated &&
    (compare(momentAZero, today) === 0 || compare(momentBZero, today) === 0)
  ) {
    return {
      valid: false,
      errors: [
        'To register for adiyogi darshan for the current day, please call our office at (931) 668-1900'
      ]
    }
  }

  const maxBookableNights = extConfig['MAX_GUEST_BOOKABLE_NIGHTS']
  if (
    !isAuthenticated &&
    !isProgramBooking &&
    daysBetween(momentA, momentB) > parseInt(maxBookableNights)
  ) {
    return {
      valid: false,
      errors: [
        `To book a stay for more than ${maxBookableNights} nights, 
        please call our office at (931) 668-1900`
      ]
    }
  }

  if (
    !isAuthenticated &&
    moment(today)
      .add(1, 'day')
      .isSame(momentA, 'day') &&
    moment().isAfter(moment(today).hour(15))
  ) {
    return {
      valid: false,
      errors: [
        'To book a stay for tomorrow, please call our office at (931) 668-1900'
      ]
    }
  }

  if (compare(momentAZero, today) === 0 && compare(momentBZero, today) === 0) {
    return {
      valid: false,
      errors: [
        'To register for adiyogi darshan for the current day, please call our office at (931) 668-1900'
      ]
    }
  }
  if (compare(momentA, momentB) >= 0) {
    return {
      valid: false,
      errors: ['Check-out date should be after Check-in date']
    }
  }
  if (checkInDate.isBefore(today, 'day')) {
    console.log("Failed validation - check-in date is before today's date")
    console.log('Check-in date: ' + momentA)
    console.log("Today's date: " + today)
    return {
      valid: false,
      errors: ["Check-in Date should be after today's date"]
    }
  }
  if (checkOutDate.isBefore(today, 'day')) {
    return {
      valid: false,
      errors: ["Check-out Date should be after today's date"]
    }
  }
  return { valid: true, errors: [] }
}



// WEBPACK FOOTER //
// ./src/logic/bookableDatesLogic.js